/**
 * @generated SignedSource<<a02d7ad3487c8fc91f45070d042d5fe1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type TodoOptionsMenu_deleteTodo_Mutation$variables = {
  id: string;
};
export type TodoOptionsMenu_deleteTodo_Mutation$data = {
  readonly deleteTodo: {
    readonly todoDeletedId: string;
  } | null;
};
export type TodoOptionsMenu_deleteTodo_Mutation = {
  response: TodoOptionsMenu_deleteTodo_Mutation$data;
  variables: TodoOptionsMenu_deleteTodo_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "todoDeletedId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "TodoOptionsMenu_deleteTodo_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "TodosDeleteMutationPayload",
        "kind": "LinkedField",
        "name": "deleteTodo",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "TodoOptionsMenu_deleteTodo_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "TodosDeleteMutationPayload",
        "kind": "LinkedField",
        "name": "deleteTodo",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "deleteRecord",
            "key": "",
            "kind": "ScalarHandle",
            "name": "todoDeletedId"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "78cd93f251fbe8d08b8d4208aa814fb6",
    "id": null,
    "metadata": {},
    "name": "TodoOptionsMenu_deleteTodo_Mutation",
    "operationKind": "mutation",
    "text": "mutation TodoOptionsMenu_deleteTodo_Mutation(\n  $id: ID!\n) {\n  deleteTodo(input: {id: $id}) {\n    todoDeletedId\n  }\n}\n"
  }
};
})();

(node as any).hash = "2400a38f1444720299a7cfbab12d760e";

export default node;
